import { InterfaceAppServiceRegister } from '@app/app.interface';
import { AppHelper } from '@app/core/app.helper';

/**
 * Сортирует и преобразовывает сырые данные рубрикатора для отображения в серекте или дереве
 * @param rubricData Данные рубрикатора
 * @param listViewAsTree Выводить деревом
 * @param listViewAsFolder Детализировать вложенность рубрикаторов
 * @param useListFullName Выводить с полным названием рубрикатора
 * @returns Преобразованные данные
 */
export const prepareRubricData = (
    rubricData: InterfaceAppServiceRegister[],
    listViewAsTree: boolean,
    listViewAsFolder: boolean,
    useListFullName: boolean,
): InterfaceAppServiceRegister[] => {
    if (!Array.isArray(rubricData) || rubricData.length === 0) {
        return [];
    }

    // Поле, обозначающее наименование рубрики (папки)
    let mainName = 'name';
    if (useListFullName) {
        mainName = 'full_name';
    }

    // Фильтр для списка
    const filterFn = listViewAsTree
        ? () => true
        : (listItem: InterfaceAppServiceRegister) => listItem.is_folder !== '1';

    // Сортировка для списка
    const sortFn = listViewAsTree ? () => 0 : AppHelper.compare({ name: -1 });

    return rubricData
        .filter(filterFn)
        .map((listItem) => {
            let name = listItem.name;
            if (listItem[mainName]) {
                name = listItem[mainName];
            }
            if (!listViewAsTree && listViewAsFolder && listItem.path_name) {
                name = listItem.path_name + ' / ' + name;
            }
            return { ...listItem, name };
        })
        .sort(sortFn);
};
